// Is an AI provider connected for this teacher? AI buttons show a calm
// disabled state instead of failing when it is not.
import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import { api } from './teacher-api';
import type { AiSettings } from './slice2';

const ready = signal<boolean | undefined>(undefined);
/** Why AI is not ready: no key on the server at all, or a key exists but no provider is picked. */
export const aiBlock = signal<'no_key' | 'not_chosen' | null>(null);
export const aiBlockText = () => (aiBlock.value === 'not_chosen' ? 'Choose an AI provider in Settings to use this' : NO_AI);
let inflight: Promise<void> | null = null;

export function refreshAiReady(): Promise<void> {
  inflight ??= api<AiSettings>('GET', '/api/t/settings/ai')
    .then((s) => {
      const ok = !!s.provider && !!s.providers.find((p) => p.id === s.provider)?.enabled;
      aiBlock.value = ok ? null : s.providers.some((p) => p.enabled) ? 'not_chosen' : 'no_key';
      ready.value = ok;
    })
    .catch(() => { aiBlock.value = 'no_key'; ready.value = false; })
    .finally(() => { inflight = null; });
  return inflight;
}

/** undefined while loading, then true/false. */
export function useAiReady(): boolean | undefined {
  useEffect(() => { if (ready.value === undefined) void refreshAiReady(); }, []);
  return ready.value;
}

export const NO_AI = 'Add an AI key in Settings to use this';
